import {StationStatusType, UserModel} from '@core/api/data-access';
import {UserStore} from '@data-users';
import {ISignCycle} from '@global-data';
import {Observable, defer, firstValueFrom} from 'rxjs';
import {SignLandingPageType} from '../sign-landing-pages.types';

export type SignLandingPageParamsType = Partial<{
	id: string;
	user: string; // signer name
	creator: string; // creator name
	rejected_by: string; // reject cycle user name
}>;

export type SignLandingPageParam = keyof SignLandingPageParamsType;

export function generateUrlFromTemplate(url: SignLandingPageType, params: Partial<Record<SignLandingPageParam, string>>): string {
	let urlWithParams: string = url;
	Object.keys(params).forEach((param: SignLandingPageParam) => {
		urlWithParams = urlWithParams.replace(`/:${param}`, `/${params[param]}`);
	});
	return `sign-landing/${urlWithParams}`;
}

export function generateLandingPageUrl(type: SignLandingPageType, cycle: ISignCycle, user: UserModel, userStore: UserStore): Observable<string> {
	return defer(async () => {
		let url = `sign-landing/${type}`;
		// extract the needed data from the landing page type (url structure):
		const urlParamsRegex = /\/:(\w+)/g;
		const urlParams: SignLandingPageParam[] = [];
		let match: RegExpExecArray | null;
		while ((match = urlParamsRegex.exec(url))) {
			urlParams.push(match[1] as SignLandingPageParam);
		}

		if (urlParams.length === 0) return url;

		const params: Partial<Record<SignLandingPageParam, string>> = {};
		for (const param of urlParams) {
			switch (param) {
				case 'id':
					params.id = cycle.id;
					break;
				case 'user':
					if (!user?.displayName) user = new UserModel(user);
					params.user = user.displayName;
					break;
				case 'creator':
					const creatorUserID: string = cycle.user;
					params.creator = await _getUserName(creatorUserID);
					break;
				case 'rejected_by':
					const rejectedUserID: string = cycle.stations.find(station => station.status === StationStatusType.Rejected)?.users.find(u => u.status === StationStatusType.Rejected)?.user;
					params.rejected_by = await _getUserName(rejectedUserID);

					break;
			}
		}

		url = generateUrlFromTemplate(type, params);
		return url;
	});

	function _getUserName(userID: string): Promise<string> {
		return firstValueFrom(userStore.loadUser(userID)).then(user => user?.user?.displayName || '');
	}
}
